import { render, staticRenderFns } from "./Sentido.vue?vue&type=template&id=3137863d&"
import script from "./Sentido.vue?vue&type=script&lang=js&"
export * from "./Sentido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports